import { vplApi } from '@/api';

export default {
  upload(data) {
    return vplApi.post('/v1/upload/', data);
  },
};
